import {forwardRef} from 'react';
import {DetailedProps, join} from '../utils';

import {Selectors} from './modal.selectors';
import styles from './modal.module.less';

export type TitleProps = DetailedProps<HTMLHeadingElement>;

export const Title = forwardRef<HTMLHeadingElement, TitleProps>(
	({className, ...props}, ref) => <h3 data-cy={Selectors.Title}
	                                    className={join(styles.title, className)}
	                                    {...props}
	                                    ref={ref}/>
);
export default Title;
